import { call, put, takeLatest } from 'redux-saga/effects';
import { cloneDeep, get, set } from 'lodash';

import history from 'browserHistory';
import { objToFormData, trims } from 'utils';
import { deleteTab, setTab } from 'modules/common/Tabs/actions';
import { BranchService } from '../../../../entities/Branches/service';
import { AADGroupService } from '../../../../entities/AADGroup/services';
import { BranchEditing } from '../../../../entities/Branches/interfaces';
import {
  getBranchError,
  getBranchSuccess,
  getBranchRequest,
  putBranchSuccess,
  putBranchError,
  putBranchRequest,
  deleteBranchError,
  deleteBranchRequest,
  postNewBranchSuccess,
  getUniqueAadRequest,
  getUniqueAadSuccess,
  getUniqueAadError,
  postSendTestMessageRequest,
  postSendTestMessageSuccess,
  postSendTestMessageError,
  getMessageCauseSuccess,
  getMessageCauseError,
} from './actions';
import {
  GET_BRANCH_REQUEST,
  PUT_BRANCH_REQUEST,
  DELETE_BRANCH_REQUEST,
  POST_NEW_BRANCH_REQUEST,
  GET_UNIQUE_AAD_REQUEST,
  POST_SEND_TEST_MESSAGE_REQUEST,
  GET_MESSAGE_CAUSE_REQUEST,
} from './constants';
import { SMSService } from '../../../../entities/SMS/service';

export function prepareData(data: any) {
  const id = get(data, 'id');
  const securityGates = get(data, 'securityGates');
  const SMCs = get(data, 'locations');
  const aadRoles = get(data, 'aadRoles');
  const ordering = get(data, 'ordering.peripheralRoles');

  aadRoles.map((role: any) => set(role, `objectId`, trims(role.objectId)));

  ordering.map((per: any, indx: any) =>
    set(data, `ordering.peripheralRoles[${indx}].peripheralUrl`, trims(per.peripheralUrl)),
  );

  securityGates.forEach((sec: any, index: any) => {
    // eslint-disable-next-line
    if (sec.isDeleted && id === 0) return delete data.securityGates[index];

    // eslint-disable-next-line
    if (sec.isDeleted) return delete data.securityGates[index].peripheralRoles;

    sec.peripheralRoles.forEach((per: any, ind: any) => {
      set(data, `securityGates[${index}].peripheralRoles[${ind}].peripheralUrl`, trims(per.peripheralUrl));

      const allowedExitTolerance = get(per, `allowedExitTolerance`, '');

      if (allowedExitTolerance && `${allowedExitTolerance}`.includes('_')) {
        const val = `${allowedExitTolerance}`.replace(/_/g, '');

        set(data, `securityGates[${index}].peripheralRoles[${ind}].allowedExitTolerance`, val);
      }
    });
  });

  SMCs.map((smc: any, index: any) => {
    // eslint-disable-next-line
    if (smc.isDeleted && id === 0) return delete data.SMCs[index];

    smc.configurations.map((s: any, idx: number) => {
      // eslint-disable-next-line
      if (s.isDeleted && id === 0) delete data.SMCs[index].configurations[idx];

      return s;
    });
    return smc;
  });

  return data;
}

function isBase64(str: string) {
  const regex = /^(?:[A-Za-z\d+/]{4})*(?:[A-Za-z\d+/]{2}==|[A-Za-z\d+/]{3}=)?$/;
  return regex.test(str);
}

function* getBranchId(action: ReturnType<typeof getBranchRequest>) {
  try {
    const branch: BranchEditing = yield call(BranchService.getBranchId, action.payload);

    branch.ordering.peripheralRoles?.forEach((role) => {
      try {
        if (isBase64(role.peripheralUrl)) {
          role.peripheralUrl = atob(role.peripheralUrl);
        }
      } catch (e) {
        console.log(e);
      }
    });

    branch.securityGates?.forEach((gate) => {
      gate?.peripheralRoles?.forEach((role) => {
        try {
          if (isBase64(role.peripheralUrl)) {
            role.peripheralUrl = atob(role.peripheralUrl);
          }
        } catch (e) {
          console.log(e);
        }
      });
    });

    console.log(branch);

    yield put(
      setTab({
        id: `branch_${action.payload}`,
        href: `/globaladmin/branch/${action.payload}`,
        title: 'Налаштування філії',
        closeRedirectPath: '/globaladmin',
      }),
    );

    console.log(branch);
    yield put(getBranchSuccess(branch));
  } catch (error: any) {
    yield put(getBranchError(error));
  }
}

function* updateBranchSaga(action: ReturnType<typeof putBranchRequest>) {
  try {
    const data = { ...action.payload };

    yield call(prepareData, data);
    yield call(BranchService.putBranchInfo, objToFormData(data));
    yield put(putBranchSuccess());
  } catch (error: any) {
    yield put(putBranchError(Error(error?.message || 'Виникла помилка')));
  }
}

function* postNewBranchSaga(action: ReturnType<typeof putBranchRequest>) {
  try {
    const data = cloneDeep(action.payload);
    yield call(prepareData, data);
    yield call(BranchService.postNewBranch, objToFormData(data));

    yield put(postNewBranchSuccess());
  } catch (error: any) {
    yield put(putBranchError(Error(error?.message || 'Виникла помилка')));
  }
}

function* deleteBranchSaga(action: ReturnType<typeof deleteBranchRequest>) {
  try {
    const { payload, isDeleted } = action;
    yield call(BranchService.deleteBranchInfo, payload, isDeleted);

    history.push('/globaladmin');
    yield put(deleteTab(`branch_${payload}`));
  } catch (error: any) {
    yield put(deleteBranchError(error));
  }
}

function* getUniqueAadSaga(action: ReturnType<typeof getUniqueAadRequest>) {
  const { payload } = action;
  try {
    yield call(AADGroupService.checkExist, payload);

    yield put(getUniqueAadSuccess([]));
  } catch (error: any) {
    yield put(getUniqueAadError(Error(error?.message || 'Виникла помилка')));
  }
}

function* postSendTestMessageSaga(action: ReturnType<typeof postSendTestMessageRequest>) {
  const { payload } = action;
  try {
    yield call(SMSService.sendTestMessage, payload);

    yield put(postSendTestMessageSuccess());
  } catch (error: any) {
    yield put(postSendTestMessageError(Error(error?.message || 'Виникла помилка')));
  }
}

function* getMessageCauseSaga() {
  try {
    // @ts-ignore
    const response: any = yield call(SMSService.getCauses);

    yield put(getMessageCauseSuccess(response));
  } catch (error: any) {
    yield put(getMessageCauseError(Error(error?.message || 'Виникла помилка')));
  }
}

export function* branchSagaWatcher() {
  yield takeLatest(GET_UNIQUE_AAD_REQUEST, getUniqueAadSaga);
  yield takeLatest(GET_BRANCH_REQUEST, getBranchId);
  yield takeLatest(PUT_BRANCH_REQUEST, updateBranchSaga);
  yield takeLatest(DELETE_BRANCH_REQUEST, deleteBranchSaga);
  yield takeLatest(POST_NEW_BRANCH_REQUEST, postNewBranchSaga);
  yield takeLatest(POST_SEND_TEST_MESSAGE_REQUEST, postSendTestMessageSaga);
  yield takeLatest(GET_MESSAGE_CAUSE_REQUEST, getMessageCauseSaga);
}
